export default {
  LayersControl: "Straturi",
  SettingsControl: "Unelte",
  settings: {
    language: {
      title: "Limbă",
      German: "Germana",
      English: "Engleză",
      Hungarian: "Maghiară",
      Romanian: "Română",
    },
    clustering: {
      title: "Gruparea elementelor",
      always: "Întotdeauna",
      never: "Niciodată",
      dynamic: "Dinamic",
    },
    functions: {
      title: "Funcții",
      print: "Printează",
      measure: "Măsurătoare",
    },
    layerLabel: "Straturi",
    transparency: "Transparenţă",
    dataPrivacy: "Impressum & Termeni şi condiţii",
    downloadMsg: "Descarca City App",
    legend: "Legenda",
    backdrop: "Fundal",
    embedLinks: "Link integrat",
  },
  buttons: {
    fullscreen: "Ecran complet",
    popout: "Desprindeți harta",
    poisAndStreets: "Puncte de interes",
    routing: "Traseu",
    close: "Închide",
    gps: "Pozitia mea",
    view3D: "Vizualizare 3D",
    weather3D: "Vreme 3D",
    streets: "Străzi",
  },
  menuPopup: {
    back: "Back to results",
    pois: "Straturi tematice",
    streets: "Străzi",
  },
  poiDetails: {
    moreInfo: "Informatii aditionale",
    openingHours: "Orar functionare",
    opened: "Deschis",
    closed: "Închis",
    showMore: "Arata mai mult",
    showLess: "arata mai putin",
    altitude: "Altitudine",
    zmin: "Cota minimă",
    zmax: "Cota maximă",
    distance: "Distanţă",
    time: "Durată",
    content: "Conţinut",
    ytitle: "Distanţă",
    xtitle: "Altitudine",
  },
  measureComponent: {
    colorSelector: "Culoare",
    shape: "Element grafic",
    measure: "Măsurătoare",
    length: "Lungimea",
    area: "Suprafata",
    radius: "Raza",
    circumference: "Circumferinţă",
    delete: "Șterge tot",
  },
  rightClickFrame: {
    startPoint: "Selecteaza punct de pornire",
    endPoint: "Selecteaza punct de sosire",
    whatIsHere: "Ce se afla aici?",
    print: "Printează",
    measure: "Măsurătoare",
  },
  routeFrame: {
    routeOptions: "Optiuni traseu",
    highway: "Autostrazi",
    tollRoad: "Sosele cu taxa",
    ferry: "Bacuri",
    units: "Unitate de masura",
    startPoint: "De la ...",
    midPoint: "Punct de mijloc ...",
    endPoint: "Spre ...",
    metric: "Metric (km)",
    imperial: "Imperial (mi)",
    via: "prin",
    departure: "Plecare:",
    details: "Detalii",
    error: "A apărut o eroare:",
    getDirections: "Calculeaza traseu",
    switchPoints: "Switch waypoints",
    close: "Închideți vizualizarea traseului",
    directions_car: "Cu masina",
    directions_bus: "Cu transportul public",
    directions_bike: "Cu bicicleta",
    directions_walk: "La pas",
  },
  streetEntry: {num: "Nr."},
  searchPlaceholder: "Caută puncte de interes, străzi sau trasee pe hartă...      ",
  searchFrame: {
    previous: "anterioara",
    next: "urmatoarea",
    loading: "Încărcare",
    error: "A apărut o eroare",
    noResults: "Nici un rezultat gasit",
    // pois: "Obiecte",
    pois: "Locuri & Trasee",
    streets: "Străzi",
    other: "Altele",
  },
  general: {
    monday: "Luni",
    tuesday: "Marți",
    wednesday: "Miercuri",
    thursday: "Joi",
    friday: "Vineri",
    saturday: "Sâmbătă",
    sunday: "Duminică",
    copy: "Copiaza",
  },
  printOverlay: {
    titlePlaceholder: "Titlu (opțional)",
    notesPlaceholder: "Descriere (opțional)",
    print: "Printează",
    close: "Închide",
    pleaseWait: "Va rugam sa asteptati cateva secunde pentru generarea documentului.",
    pleaseWaitSubscript: "",
  },
  gdpr: {
    title: "Notificare GDPR",
    message:
      "Acest site folosește cookie-uri pentru a îmbunătăți experiența utilizatorului. Cu „Ok” confirmați că această evaluare poate fi efectuată ",
    ok: "Ok",
    no: "nu, mulțumesc",
  },
  wfs: {
    intro_description: "Vă rugăm să selectați un element de pe hartă pentru a vedea detaliile acestuia.",
    no_elem_found: "Nu a fost găsit niciun element în această locație.",
    unknown_error: "A apărut o eroare necunoscută: ",
  },
 routing: {
  title: "Traseu",
  instructionsTitle: "Instrucțiuni",
  showMore: "Arată mai mult",
  showLess: "Arată mai puțin",
  startPlaceholder: "Caută start / click pe hartă",
  endPlaceholder: "Caută destinație / click pe hartă",
  useMyLocation: "Folosește locația mea",
  needBothPoints: "Selectează punctul de plecare și destinația pentru a vedea instrucțiunile.",
  loading: "Se încarcă traseul..."
},
instructions: {
  // sens giratoriu
  "sens giratoriu":                       { icon: "sync",              text: "Sens giratoriu" },

  // ușor la dreapta/stânga (pune-le înaintea celor generale)
  "schimbați direcția la ușor la dreapta":{ icon: "turn_slight_right", text: "Ușor la dreapta" },
  "schimbati directia la usor la dreapta":{ icon: "turn_slight_right", text: "Ușor la dreapta" },
  "ușor la dreapta":                      { icon: "turn_slight_right", text: "Ușor la dreapta" },
  "usor la dreapta":                      { icon: "turn_slight_right", text: "Ușor la dreapta" },

  "schimbați direcția la ușor la stânga": { icon: "turn_slight_left",  text: "Ușor la stânga" },
  "schimbati directia la usor la stanga": { icon: "turn_slight_left",  text: "Ușor la stânga" },
  "ușor la stânga":                       { icon: "turn_slight_left",  text: "Ușor la stânga" },
  "usor la stanga":                       { icon: "turn_slight_left",  text: "Ușor la stânga" },

  // la dreapta/stânga
  "schimbați direcția la dreapta":        { icon: "turn_right",        text: "Virați la dreapta" },
  "schimbati directia la dreapta":        { icon: "turn_right",        text: "Virați la dreapta" },
  "la dreapta":                           { icon: "turn_right",        text: "Virați la dreapta" },

  "schimbați direcția la stânga":         { icon: "turn_left",         text: "Virați la stânga" },
  "schimbati directia la stanga":         { icon: "turn_left",         text: "Virați la stânga" },
  "la stânga":                            { icon: "turn_left",         text: "Virați la stânga" },
  "la stanga":                            { icon: "turn_left",         text: "Virați la stânga" },

  // țineți/mențineți banda
  "țineți dreapta":                       { icon: "fork_right",        text: "Țineți dreapta" },
  "tineti dreapta":                       { icon: "fork_right",        text: "Țineți dreapta" },
  "mențineți dreapta":                    { icon: "fork_right",        text: "Țineți dreapta" },
  "mentineți dreapta":                    { icon: "fork_right",        text: "Țineți dreapta" },

  "țineți stânga":                        { icon: "fork_left",         text: "Țineți stânga" },
  "tineti stanga":                        { icon: "fork_left",         text: "Țineți stânga" },
  "mențineți stânga":                     { icon: "fork_left",         text: "Țineți stânga" },
  "mentineți stanga":                     { icon: "fork_left",         text: "Țineți stânga" },

  // continua
  "continuați":                           { icon: "straight",          text: "Continuați" },
  "continua":                             { icon: "straight",          text: "Continuați" },
  "continuă":                             { icon: "straight",          text: "Continuați" },

  "rămâneți pe banda stângă": { icon: "fork_left",  text: "Rămâneți pe banda stângă" },
  "ramaneti pe banda stanga": { icon: "fork_left",  text: "Rămâneți pe banda stângă" },
  "păstrați banda stângă":    { icon: "fork_left",  text: "Rămâneți pe banda stângă" },
  "pastrati banda stanga":    { icon: "fork_left",  text: "Rămâneți pe banda stângă" },

  "rămâneți pe banda dreaptă":{ icon: "fork_right", text: "Rămâneți pe banda dreaptă" },
  "ramaneti pe banda dreapta":{ icon: "fork_right", text: "Rămâneți pe banda dreaptă" },
  "păstrați banda dreaptă":   { icon: "fork_right", text: "Rămâneți pe banda dreaptă" },
  "pastrati banda dreapta":   { icon: "fork_right", text: "Rămâneți pe banda dreaptă" },
   // U-turn
  "întoarceți":           { icon: "u_turn_left", text: "Întoarceți" },
  "intoarceti":           { icon: "u_turn_left", text: "Întoarceți" },

  // Waypoint
  "waypoint":             { icon: "place",       text: "Punct intermediar" },
  "punct intermediar":    { icon: "place",       text: "Punct intermediar" }
},
 rotateOverlay: {
    message: "Te rugăm să rotești telefonul în modul portret pentru a vizualiza harta."
  }

};
